import React from "react";

const MainLogin = ({ children }) => <div>{children}</div>;

export default MainLogin;
